import React, { useContext } from 'react';
import { A } from 'hookrouter';

import { DataContext } from '../../../stores/emp-table-store';
import OnHoverTooltip from '../shared/OnHoverTooltip';
import { useTranslation } from 'react-i18next';
import { EMP_TABLE_HOURS_DESC } from '../../../i18n/keyConstants';
import { employeeStatusOptions, translateOptionValue } from '../../exl/shared/translations';


const RowDetail = ({ row }) => {
    const { store } = useContext(DataContext);
    const { columns } = store;
    const { t } = useTranslation(['employeeTable']);


    const rows = columns.map((item) => {
        return Object.keys(row).includes(item.name) ? { title: item.title, value: row[item.name], name: item.name } : null;
    });

    const RowDetailValue = (item) => {
        if (item.name === 'name') {
            return (
                <A href={`/employee/${row.id}/info`} className='btn btn-link padding-none'>
                    {item.value}
                </A>
            );
        }
        if (item.name === 'boss') {
            return (
                <A href={`/employee/${row.bosEmpID}/info`} className='btn btn-link padding-none'>
                    {item.value}
                </A>
            );
        }
        if (item.name === 'office') {
            return (
                <A href={`/office/${row.officeId}`} className='btn btn-link padding-none'>
                    {item.value}
                </A>
            );
        }
        if (item.name === 'status') {
            return t(translateOptionValue(item.value, employeeStatusOptions), {ns: 'shared'});
        }
        return item.value;
    };

    return (
        <div className='employee-info padding-left-60px'>
            <div className='row'>
                {rows &&
                    rows
                        .filter((item) => item !== null && item.value !== null && item.value !== '')
                        .map((item, index) => (
                            <div className='col-6 col-md-3 col-lg-2' key={index}>
                                {item.name === 'hours' ? (
                                    <OnHoverTooltip
                                        labelClassNames=''
                                        dataFor='hours-label'
                                        tooltipType='dark'
                                        tooltipPlace='top'>

                                        <span>{item.title}</span>
                                        <span>{t(EMP_TABLE_HOURS_DESC)}</span>

                                    </OnHoverTooltip>
                                ) : (
                                    <label>{item.title}</label>
                                )}
                                <p>{RowDetailValue(item)}</p>
                            </div>
                        ))}
            </div>
        </div>
    );
};

export default RowDetail;
